import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import pathfinder from "./../../../../assets/info/pathfinder-hero.jpg";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const NissanPathfinder = () => {
  useSmallNav("Nissan Pathfinder");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Nissan Pathfinder"} bolder />
        <InfoHero image={pathfinder} />
        <InfoGrid>
          <div>
            <p>
              Nadchodzi brat Navary w wersji hatchback i jest to świetny,
              wszechstronny pojazd.
            </p>
            <p>
              W Pedders posiadamy szeroką gamę części i zestawów zawieszenia
              umożliwiających naprawę lub ulepszenie Twojego Pathfindera.
            </p>
            <p>
              Chcesz poprawić zdolność holowania? Jeśli holujesz lub ładujesz
              Pathfindera, prawdopodobnie już zauważyłeś, że jest on dość miękki
              z tyłu. Oferujemy zestawy ulepszeń, które pozwolą Ci holować z
              większą pewnością, bez pogarszania komfortu i jazdy Pathfinderem,
              gdy nie holujesz.
            </p>
            <p>
              Chcesz go podnieść do użytku w terenie? Więc nie szukaj dalej. My
              też mamy takie zestawy. (obecnie niedostępne dla modeli R51). W
              zależności od modelu do 2,5 cala wzniosu w celu zwiększenia
              prześwitu i miejsca na większe opony.
            </p>
            <p>
              Jeśli potrzebujesz części zawieszenia w celu wymiany części, które
              są zużyte lub nie przeszły przeglądu technicznego, również je
              mamy. Podobnie jak w przypadku wszystkich produktów Pedders,
              kiedykolwiek projektujemy nowy produkt, zawsze staramy się
              ulepszyć oryginał, czy to w celu poprawy wydajności, czy
              zwiększenia trwałości.
            </p>
            <p>
              Nadal nie jesteś czegoś pewien? Masz pytanie? Skontaktuj się z
              nami, ktoś z naszego zespołu będzie w stanie Ci pomóc.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Nissan")
              .models.find((e) => e.display === "Pathfinder")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Nissan" model="Pathfinder" /> */}
      </Container>
    </section>
  );
};

export default NissanPathfinder;
